import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { OuterBox } from 'components/OuterBox/OuterBox';
import { Separator } from 'components/Separator/Separator';
import { SubTitle } from 'components/SubTitle/SubTitle';
import { TeaserText } from 'components/TeaserText/TeaserText';

import { TENANT_ID } from 'global/constants';

import { getArticlesOverviewPath, getEventsOverviewPath } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import './MessageBox.scss';

export const MessageBox = ({ data }) => {
  /**
   * TODO: routes should come from AEM. Probably we should fetch them on App initialisation and put them
   * into context so we can grab them here out of the context-provider
   */

  const getLink = () =>
    data.buttonText === 'Zu den Fachbeiträgen'
      ? getArticlesOverviewPath()
      : getEventsOverviewPath();

  const { url } = data;
  return (
    <div className="message-box">
      <OuterBox className="message-box__outer-box">
        <SubTitle text={data.title} notFramed />
        <Separator color={getTenantId() === TENANT_ID.AVA ? 'homepage' : 'secondary'} />
        <TeaserText className="message-box__teaser" text={data.text} />
        <ActionButton
          title={data.buttonText}
          link={url ? undefined : getLink()}
          onClick={
            url
              ? () => {
                  window.location.href = url;
                }
              : undefined
          }
          inverted
        />
      </OuterBox>
    </div>
  );
};

MessageBox.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string,
    buttonText: PropTypes.string,
  }),
};

MessageBox.defaultProps = {
  data: {
    title: '',
    text: '',
    url: '',
    buttonText: '',
  },
};
